import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Callbacks from './callbacks'

const withContainer = Component => props => {
  const setFormValues = hooks.useFormChange()
  const { openNotification } = hooks.useNotification()
  const [isReadOnly] = hooks.useFormState('isReadOnly')
  const [record_id] = hooks.useFormState('record_id')
  const [resetIdentifiers] = hooks.useModelFunction('companyuser', 'refreshIdentifiers')

  const onConfirmResetIdentifier = useCallback(Callbacks.onConfirmResetIdentifierHandler(resetIdentifiers, openNotification, setFormValues, isReadOnly, record_id), [resetIdentifiers, openNotification, setFormValues, isReadOnly, record_id])

  const mergedProps = {
    onConfirmResetIdentifier
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
